export default "__VITE_ASSET__BXpDcH6D__"